module.exports = __webpack_public_path__ + "img/sergio.32d41688.png";